"use client";

import { scrollFieldIntoView } from "utils/scrollFieldIntoView";
import { LOCATION_COPY, DROP_OFF_TOGGLE } from "@1-now/booking-core";
import { FC } from "react";

import { useData } from "data/data-provider";

import LocationInput from "../../../Common/LocationInput";
import DropOffLocationInput from "designs/Common/DropOffLocationInput";
import RentalCarDatesRangeInput from "designs/Common/(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "designs/Common/(car-search-form)/RentalCarTimesRangeInput";
import SearchButton from "designs/DesignB/components/SearchButton/SearchButton";

export interface RentalCarSearchFormProps { }

const MobileSearch: FC<RentalCarSearchFormProps> = () => {
  const {
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    dropOffLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
    ourLocation,
  } = useData();

 const hasDropoffLocations = ourLocation.some(
    (loc) =>
      loc.active !== false &&
      (loc.location_type === "drop_off" || loc.location_type === "both")
  );

  const renderRadioBtn = () => {
    return (
      <div className="flex items-center flex-wrap flex-row mb-3">
        <div className="grid grid-cols-2 gap-1 w-full bg-text-color/[0.06] rounded-[10px] p-1">
          <div
            className={`py-2.5 flex items-center justify-center rounded-lg cursor-pointer text-sm leading-5 ${dropoffLocationType === true
                ? "bg-card-color text-text-color shadow-sm font-semibold"
                : "text-secondary-text-color font-medium"
              }`}
            onClick={(e) => {
              const currentLocation = pickupLocation ?? dropOffLocation;
              setDropoffLocationType(true);
              setSameDropoffLocation(true);
              setDropoffLocation(null);
              setSearchedDropoffLocation("");
              if (currentLocation) {
                setPickupLocation(currentLocation);
                setSearchedPickupLocation(currentLocation.name ?? "");
              }
            }}
          >
            {DROP_OFF_TOGGLE.same}
          </div>
          <div
            className={`py-2.5 flex items-center justify-center rounded-lg text-sm leading-5 cursor-pointer ${dropoffLocationType === false
                ? "bg-card-color text-text-color shadow-sm font-semibold"
                : "text-secondary-text-color font-medium"
              }`}
            onClick={() => {
              setDropoffLocationType(false);
              setSameDropoffLocation(false);
              const activeLocations = ourLocation.filter((loc) => loc.active !== false);
              if (activeLocations.length === 1) {
                setPickupLocation(activeLocations[0]);
                setDropoffLocation(activeLocations[0]);
                setSearchedPickupLocation(activeLocations[0].name ?? "");
                setSearchedDropoffLocation(activeLocations[0].name ?? "");
              } else {
                setPickupLocation(null);
                setDropoffLocation(null);
                setSearchedDropoffLocation("");
                setSearchedPickupLocation("");
              }
            }}
          >
            {DROP_OFF_TOGGLE.different}
          </div>
        </div>
      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative content-center items-center z-40">
      {hasDropoffLocations && renderRadioBtn()}
      <div
        className={`relative flex flex-col  ${isDdropOffdifferent ? "md:grid md:grid-cols-1 md:gap-2" : ""
          }`}
      >
        <div
          className={`${isDdropOffdifferent ? " " : "w-full my-1.5"}`}
          onClick={(e) => {
            if (window.innerWidth < 768) scrollFieldIntoView(e.currentTarget);
          }}
        >
          <LocationInput
          labelPosition="bottom"
            placeHolder={
              isDdropOffdifferent
                ? LOCATION_COPY.pickUp.label
                : LOCATION_COPY.same.label
            }
            desc={
              isDdropOffdifferent
                ? LOCATION_COPY.pickUp.prompt
                : LOCATION_COPY.same.prompt
            }
            className="w-full rounded-[10px] border border-text-color/15"
            sameDropOffLocation={dropoffLocationType === false}
            searchBar={false}
          />
        </div>
        {isDdropOffdifferent && (
          <div
            className="my-1.5"
            onClick={(e) => {
            if (window.innerWidth < 768) scrollFieldIntoView(e.currentTarget);
          }}
          >
            <DropOffLocationInput
          labelPosition="bottom"
              placeHolder={LOCATION_COPY.dropOff.label}
              className="w-full rounded-[10px] border border-text-color/15"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </div>
        )}
      </div>
      <div className="relative flex flex-col">
        <RentalCarDatesRangeInput className="w-full rounded-[10px] border border-text-color/15 my-1.5" />

        <RentalCarTimesRangeInput
          dropOffLocationType={dropoffLocationType}
          className="w-full rounded-[10px] border border-text-color/15 my-1.5"
        />
      </div>
      <div className="db-phone-search mt-3">
        <SearchButton />
      </div>
    </form>
  );
};

export default MobileSearch;
